module.exports = "/_next/static/images/smallBackground-239967bcc4d33effa761675355375f3c.png";